import { MAX_GAP_SIZE } from '../constants.js';

export const calculateGap = (candidateWidth: number, ctnWidth: number) => {
  const candidateTileRatio = candidateWidth / ctnWidth;
  const gapRatio = candidateTileRatio / 10;
  const relativeGap = Math.floor(gapRatio * ctnWidth);

  return Math.min(relativeGap, MAX_GAP_SIZE);
};
